import axios from '@/axios.js'

const state = () => ({
    absenumums: [],
    absenkegiatans: [],
    absenwfhs: [],
    analisisKehadiranList: [],
    analisisKehadiranAtr: [],
    tanggalTanggal: [],
    tanggalData: [],
    persenAtribut: [],
    persenSeries: [],
    listPegawaiPresentase: [],
})

const mutations = {
  SET_ABSENUMUM (state, payload) {
    state.absenumums = payload
  },
  SET_ABSENKEGIATAN (state, payload) {
    state.absenkegiatans = payload
  },
  SET_ABSENWFH (state, payload) {
    state.absenwfhs = payload
  },
  SET_KEHADIRAN (state, payload) {
    state.analisisKehadiranList = payload.kehadiran
    state.analisisKehadiranAtr = payload.atribut
  },
  SET_TANGGAL (state, payload) {
    state.tanggalTanggal = payload.tanggal
    state.tanggalData = payload.series
  },
  SET_PERSENTASE (state, payload) {
    state.persenAtribut = payload.atribut
    state.persenSeries = payload.series
  },
  SET_LISTPEGAWAI (state, payload) {
    state.listPegawaiPresentase = payload
  },
}

const actions = {
  fetchAbsenumum ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/analisis-list-umum')
        .then((response) => {
          commit('SET_ABSENUMUM', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAbsenkegiatan ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/analisis-list-kegiatan')
        .then((response) => {
          commit('SET_ABSENKEGIATAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAbsenwfh ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/analisis-list-wfh')
        .then((response) => {
          commit('SET_ABSENWFH', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAnalisisKehadiran ({ commit }, tanggal) {
    return new Promise((resolve, reject) => {
      axios.get(`/analisis-kehadiran/${tanggal}`)
        .then((response) => {
          commit('SET_KEHADIRAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAnalisisTanggal ({ commit }, tanggal) {
    return new Promise((resolve, reject) => {
      axios.get(`/analisis-tanggal/${tanggal}`)
        .then((response) => {
          commit('SET_TANGGAL', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAnalisisPresentase ({ commit }, tanggal) {
    return new Promise((resolve, reject) => {
      //axios.get(`/analisis-persentase/${tanggal.min}/${tanggal.max}`)
      axios.get(`/analisis-persentase/${tanggal}`)
        .then((response) => {
          commit('SET_PERSENTASE', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchList ({ commit }, pilihAtr) {
    return new Promise((resolve, reject) => {
      axios.get(`/list-pegawai/${pilihAtr.tanggal}/${pilihAtr.listset}`)
        .then((response) => {
          commit('SET_LISTPEGAWAI', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}